import { IBrowserNative, INativeProxy } from './lib/interface';
import AMapHelper from '@/utils/maps/gaodeMap';
import params from '@/utils/params';
import Storage from '@/utils/storage';
import Cookie from '@/utils/cookie';
// 端外用车相关bridge
import Bridge from './bridge';

function getValueFormUrlOrUserCache(keyName: string) {
  let value = params.get(keyName, window.location.href);
  if (!value || value === 'undefined') {
    const loginResult = Storage.getItem('login_result');
    if (loginResult) {
      // @ts-ignore
      value = loginResult[keyName];
    }
  }
  return value;
}

const NativeProxy: INativeProxy = {
  // 跳转链接
  goLinkUrl(url) {
    if (typeof url === 'string') {
      window.location.href = url;
    }
    return Promise.resolve();
  },
  redirectTo(url) {
    // @ts-ignore
    window.location.replace(url);
    return Promise.resolve();
  },
  goBack() {
    window.history.go(-1);
    return Promise.resolve();
  },
  // h5定位
  async getCityInfo() {
    try {
      const position = await AMapHelper.getCurrentLocation();
      console.info('getCityInfo-browser=====================', position);
      const {
        lat,
        lng,
        longitude,
        latitude,
        adcode,
        adCode,
        citycode,
        cityCode,
      } = ((position || {}) as unknown) as {
        lat: number;
        lng: number;
        longitude: number;
        latitude: number;
        adcode: string;
        adCode: string;
        citycode: string;
        cityCode: string;
      };

      console.info('getCityInfo-browser-result=====================', {
        adCode: adCode || adcode,
        cityCode: cityCode || citycode,
        latitude: latitude || lat,
        longitude: longitude || lng,
      });
      return {
        adCode: adCode || adcode,
        cityCode: cityCode || citycode,
        latitude: latitude || lat,
        longitude: longitude || lng,
      };
    } catch (e) {
      return {
        province: '萨嘎',
        cityCode: '0892',
        adCode: '540236',
        longitude: 85.23325,
        latitude: 29.32848,
      };
    }
  },
  getTokenAndKey() {
    // @ts-ignore
    const ticket = params.getTicket('ticket');
    const mobile = getValueFormUrlOrUserCache('mobile');
    const guid = getValueFormUrlOrUserCache('guid');
    const openId = getValueFormUrlOrUserCache('openId');
    const unionId = getValueFormUrlOrUserCache('unionid');
    const token = getValueFormUrlOrUserCache('token');
    const userInfo = {
      token,
      mobile,
      unionId,
      openId,
      guid,
      ticket,
    };
    if (!ticket || ticket === 'undefined') {
      const loginResult = Storage.getItem('login_result');
      if (loginResult) {
        // @ts-ignore
        userInfo.ticket = loginResult.ticket;
      }
    }
    if (token) {
      Storage.setItem('login_result', userInfo);
      Cookie.setItem('user_token', token);
    }
    return Promise.resolve(userInfo);
  },
  setTitle(title) {
    if (typeof title === 'string') {
      document.title = title;
    }
    return Promise.resolve();
  },
  async scanQRCode(): Promise<any> {
    const res = await Bridge.scan({});
    return res;
  },
  async chooseImage(args?: any) {
    return await Bridge.addPhoto(args);
  },
  async uploadFile(args?: any) {
    return await Bridge.uploadFile(args);
  },
};

const BrowserNative = ({ method, params }: IBrowserNative) => {
  if (NativeProxy[method]) {
    return NativeProxy[method].call(NativeProxy, params);
  }
  console.error(`NativeProxy_alipayMini ${method} is not implement`);
  return Promise.resolve();
};
export default BrowserNative;
